/** Separador de miles: 1234.5 -> "1.234,5" */
function toThousand(n) {
    const [integerPart, decimalPart] = n.toFixed(1).split('.');
    return `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decimalPart}`;
}

const MONEDA_DOLAR = 1;

/**
 * Precio de venta expresado en dólares.
 *
 * Si moneda_venta no es dólar, se convierte con la cotización. Devuelve null
 * cuando falta el precio o todavía no llegaron las cotizaciones: así el que
 * llama muestra un placeholder en lugar de "U$S NaN".
 */
export function formatPriceUsd(precio, { dolar, euro } = {}) {
    if (!precio || typeof precio.precio_venta === 'undefined' || precio.precio_venta === null) {
        return null;
    }

    if (precio.moneda_venta === MONEDA_DOLAR) {
        return `U$S ${String(precio.precio_venta).replace('.', ',')} + iva`;
    }

    if (!dolar || !euro) return null; // sin cotización todavía

    return `U$S ${toThousand((precio.precio_venta * euro) / dolar)} + iva`;
}
